module.exports = __webpack_public_path__ + "img/miata-gt-19.eb2efe32.png";